import { Slot } from 'expo-router';

export default Slot;
